module.exports = __webpack_public_path__ + "static/media/assembly_V1.1df8215c.png";